module.exports = __webpack_public_path__ + "img/branco_vertical.40ae5b5d.png";